import React from 'react';

export const Loader: React.FC = () => {
    const scale = 1;

    return (
        <div
            className='fixed top-1/2 left-1/2 inline-block z-[1]'
            style={{
                transform: `translate(-50%, -50%) scale(${scale})`,
            }}
        >
            <div className="relative w-10 h-10">
                <div className="absolute w-1 h-1 bg-black rounded-full animate-loader" style={{ top: '18.5px', left: '33px', animationDelay: '0s' }} />
                <div className="absolute w-1 h-1 bg-black rounded-full animate-loader" style={{ top: '11px', left: '31px', animationDelay: '-0.075s' }} />
                <div className="absolute w-1 h-1 bg-black rounded-full animate-loader" style={{ top: '5.5px', left: '26px', animationDelay: '-0.15s' }} />
                <div className="absolute w-1 h-1 bg-black rounded-full animate-loader" style={{ top: '3.5px', left: '18.5px', animationDelay: '-0.225s' }} />
                <div className="absolute w-1 h-1 bg-black rounded-full animate-loader" style={{ top: '5.5px', left: '11px', animationDelay: '-0.3s' }} />
                <div className="absolute w-1 h-1 bg-black rounded-full animate-loader" style={{ top: '11px', left: '5.5px', animationDelay: '-0.375s' }} />
                <div className="absolute w-1 h-1 bg-black rounded-full animate-loader" style={{ top: '18.5px', left: '3.5px', animationDelay: '-0.45s' }} />
                <div className="absolute w-1 h-1 bg-black rounded-full animate-loader" style={{ top: '26px', left: '5.5px', animationDelay: '-0.525s' }} />
                <div className="absolute w-1 h-1 bg-black rounded-full animate-loader" style={{ top: '31px', left: '11px', animationDelay: '-0.6s' }} />
                <div className="absolute w-1 h-1 bg-black rounded-full animate-loader" style={{ top: '33px', left: '18.5px', animationDelay: '-0.675s' }} />
                <div className="absolute w-1 h-1 bg-black rounded-full animate-loader" style={{ top: '31px', left: '26px', animationDelay: '-0.75s' }} />
                <div className="absolute w-1 h-1 bg-black rounded-full animate-loader" style={{ top: '26px', left: '31px', animationDelay: '-0.825s' }} />
            </div>
        </div>
    );
};